import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './PopoverContent.module.css'

interface PopoverContentProps {
  translationKey: string
  children?: React.ReactNode
}

const PopoverContent: React.FC<PopoverContentProps> = ({ translationKey, children }) => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex gap-l padding-m ${styles.container}`}>
      <span className='font-body-medium-regular' dangerouslySetInnerHTML={{ __html: t(translationKey) }} />
      {children}
    </div>
  )
}

export default PopoverContent
